import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Austin Andrews
 * id 922A0C03-C46D-45E7-8B44-9D53F1292360
 * name chart-timeline
 * version: 1.6.50
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/chart-timeline.svg
 * tags
 * - Math 
 */
export const ChartTimelineIcon = createSvgIcon(<><path d="M2,2H4V20H22V22H2V2M7,10H17V13H7V10M11,15H21V18H11V15M6,4H22V8H20V6H8V8H6V4Z" /></>, 'ChartTimelineIcon');
export default ChartTimelineIcon